import React from 'react'

import PartialCTA from './cta'

const TwbCTA = ({ block }) => (
  <section className={`partial ${block._template}`}>
    <PartialCTA data={block} />
  </section>
)

export default TwbCTA
